import { Container, StyledInput } from "./style";
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className: string;
  label: string;
  name: string;
  register: any;
}

const Input = ({ className, label, register, name, ...rest }: InputProps) => {
  return (
    <Container>
      <StyledInput name={name} {...register(name)} label={label} {...rest} />
    </Container>
  );
};

export default Input;
